document.addEventListener('DOMContentLoaded', function() {

  function handleCheckboxChange(checkbox) {
    const hiddenInputId = checkbox.dataset.hiddenInputId;
    const hiddenInput = document.getElementById(hiddenInputId);
    if (hiddenInput) {
      hiddenInput.value = checkbox.checked ? 'Yes' : 'No';
    }
  }

  function handleTextInputChange(input) {
    const hiddenInputId = input.dataset.hiddenInputId;
    const hiddenInput = document.getElementById(hiddenInputId);
    if (hiddenInput) {
      hiddenInput.value = input.value;
    }
  }

  function handleOptionInputChange(optionInputs) {
    optionInputs.forEach(input => {
      const productFormInput = document.getElementById(`product-form-input-${input.dataset.optionName}-${input.dataset.blockId}`);
      if (!productFormInput) {
        return;
      }

      function updateFields(value) {
        productFormInput.value = value;
      }

      input.addEventListener('change', function() {
        updateFields(this.value);
      });

      if (input.checked || input.tagName === 'SELECT') {
        updateFields(input.value);
      }
    });
  }

  // Handle checkboxes
  const customCheckboxes = document.querySelectorAll('.custom-checkbox-input');
  customCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', function() {
      handleCheckboxChange(checkbox);
    });
  });

  // Handle text inputs
  const customTextInputs = document.querySelectorAll('.custom-text-field');
  customTextInputs.forEach(input => {
    input.addEventListener('input', function() {
      handleTextInputChange(input);
    });
  });

  // Handle option inputs
  const optionInputs = document.querySelectorAll('input[name^="custom_option_"], select[name^="custom_option_"]');
  if (optionInputs.length > 0) {
    handleOptionInputChange(optionInputs);
  }
  
  // Handle keyring type radio buttons
  function attachKeyringListeners() {
    const keyringRadios = document.querySelectorAll('.keyring-radio');
    console.log('Found keyring radios:', keyringRadios.length);
    
    keyringRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        updateKeyringHiddenField(this.value);
      });
      
      // Set initial value if checked
      if (radio.checked) {
        updateKeyringHiddenField(radio.value);
      }
    });
  }

  function updateKeyringHiddenField(value) {
    const hiddenInput = document.getElementById('hidden-keyring-type');
    console.log('Keyring changed to:', value);
    if (hiddenInput) {
      hiddenInput.value = value;
      console.log('Updated hidden field to:', hiddenInput.value);
    } else {
      console.error('Hidden keyring field not found!');
    }
  }

  // Handle NoBody design radio buttons
  function attachDesignListeners() {
    const designRadios = document.querySelectorAll('.design-radio[name="nobody_design_selection"]');
    console.log('Found Nobody design radios:', designRadios.length);
    
    designRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        updateDesignHiddenField(this.value);
      });
      
      // Set initial value if checked
      if (radio.checked) {
        updateDesignHiddenField(radio.value);
      }
    });
  }

  function updateDesignHiddenField(value) {
    const hiddenInput = document.getElementById('hidden-nobody-design');
    console.log('Nobody design changed to:', value);
    if (hiddenInput) {
      hiddenInput.value = value;
      console.log('Updated hidden field to:', hiddenInput.value);
    } else {
      console.error('Hidden Nobody design field not found!');
    }
  }

  // Handle MinTeddy design radio buttons
  function attachMinteddyDesignListeners() {
    const minteddyDesignRadios = document.querySelectorAll('.design-radio[name="minteddy_design_selection"]');
    console.log('Found MinTeddy design radios:', minteddyDesignRadios.length);
    
    minteddyDesignRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        updateMinteddyDesignHiddenField(this.value);
      });
      
      // Set initial value if checked
      if (radio.checked) {
        updateMinteddyDesignHiddenField(radio.value);
      }
    });
  }

  function updateMinteddyDesignHiddenField(value) {
    const hiddenInput = document.getElementById('hidden-minteddy-design');
    console.log('MinTeddy design changed to:', value);
    if (hiddenInput) {
      hiddenInput.value = value;
      console.log('Updated MinTeddy design field to:', hiddenInput.value);
    } else {
      console.error('Hidden MinTeddy design field not found!');
    }
  }

  // Handle MinTeddy heart color radio buttons
  function attachMinteddyHeartListeners() {
    const heartColorRadios = document.querySelectorAll('input[name="heart_color_selection"]');
    console.log('Found MinTeddy heart color radios:', heartColorRadios.length);
    
    heartColorRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        updateMinteddyHeartHiddenField(this.value);
      });
      
      // Set initial value if checked
      if (radio.checked) {
        updateMinteddyHeartHiddenField(radio.value);
      }
    });
  }

  function updateMinteddyHeartHiddenField(value) {
    const hiddenInput = document.getElementById('hidden-heart-color');
    console.log('MinTeddy heart color changed to:', value);
    if (hiddenInput) {
      hiddenInput.value = value;
      console.log('Updated MinTeddy heart color field to:', hiddenInput.value);
    } else {
      console.error('Hidden MinTeddy heart color field not found!');
    }
  }

  // Attach listeners initially
  attachKeyringListeners();
  attachDesignListeners();
  attachMinteddyDesignListeners();
  attachMinteddyHeartListeners();

  // Re-attach listeners when variant changes (for AJAX updates)
  document.addEventListener('variant:change', function() {
    console.log('Variant changed - re-attaching listeners');
    setTimeout(function() {
      attachKeyringListeners();
      attachDesignListeners();
      attachMinteddyDesignListeners();
      attachMinteddyHeartListeners();
    }, 100);
  });

  // CRITICAL: Update hidden fields right before form submission
  function attachFormSubmitListener() {
    const productForms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    console.log('Found product forms:', productForms.length);
    
    if (productForms.length === 0) {
      console.log('No forms found yet, retrying...');
      setTimeout(attachFormSubmitListener, 200);
      return;
    }
    
    productForms.forEach(form => {
      // Check if listener already attached
      if (form.dataset.listenerAttached) {
        console.log('Listener already attached to form');
        return;
      }
      form.dataset.listenerAttached = 'true';
      
      console.log('Attaching submit listener to form');
      
      form.addEventListener('submit', function(e) {
      console.log('🚀 Form submitting - ensuring values are set');
      
      // Kolla om vi har MinTeddy bear color vald
      const checkedBearColor = document.querySelector('input[name="bear_color_selection"]:checked');
      
      // Om MinTeddy - STOPPA formuläret DIREKT
      if (checkedBearColor) {
        e.preventDefault();
        e.stopImmediatePropagation();
        console.log('🛑 Stopped default form submit for MinTeddy');
      }
      
      // Update keyring value
      const checkedKeyring = document.querySelector('.keyring-radio:checked');
      if (checkedKeyring) {
        console.log('Updating keyring before submit:', checkedKeyring.value);
        updateKeyringHiddenField(checkedKeyring.value);
      }
      
      // Update Nobody design value
      const checkedDesign = document.querySelector('.design-radio[name="nobody_design_selection"]:checked');
      if (checkedDesign) {
        console.log('Updating Nobody design before submit:', checkedDesign.value);
        updateDesignHiddenField(checkedDesign.value);
      }
      
      // Update MinTeddy design value
      const checkedMinteddyDesign = document.querySelector('.design-radio[name="minteddy_design_selection"]:checked');
      if (checkedMinteddyDesign) {
        console.log('Updating MinTeddy design before submit:', checkedMinteddyDesign.value);
        updateMinteddyDesignHiddenField(checkedMinteddyDesign.value);
      }
      
      // Update MinTeddy heart color value
      const checkedHeartColor = document.querySelector('input[name="heart_color_selection"]:checked');
      if (checkedHeartColor) {
        console.log('Updating MinTeddy heart color before submit:', checkedHeartColor.value);
        updateMinteddyHeartHiddenField(checkedHeartColor.value);
      }
      
      // Update MinTeddy bear color - Use Cart API
      if (checkedBearColor) {
        const productData = window.ShopifyAnalytics?.meta?.product;
        console.log('🔍 Product data:', productData ? 'found' : 'not found');
        
        if (productData) {
          const matchingVariant = productData.variants.find(v => 
            v.name === checkedBearColor.value || 
            v.name.includes(checkedBearColor.value) ||
            v.public_title === checkedBearColor.value
          );
          
          console.log('🔍 Matching variant:', matchingVariant);
          
          if (matchingVariant) {
          console.log('✅ Using Cart API with variant:', matchingVariant.id);
          
          // Samla properties från dolda fält
          const formData = new FormData(form);
          const properties = {};
          
          for (let [key, value] of formData.entries()) {
            if (key.startsWith('properties[')) {
              const propName = key.match(/properties\[(.*?)\]/)[1];
              if (value) properties[propName] = value;
            }
          }
          
          console.log('Properties:', properties);
          
          // Hitta quantity-fältet (kan vara utanför form)
          const quantityInput = document.querySelector('.quantity__input') || 
                                document.querySelector('[name="quantity"]') ||
                                form.querySelector('input[type="number"]');
          
          const quantityValue = quantityInput ? parseInt(quantityInput.value) : 1;
          console.log('🔢 Quantity to add:', quantityValue);
          
          // Skicka till Cart API
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: matchingVariant.id,
                quantity: quantityValue,
                properties: properties
              }]
            })
          })
          .then(r => r.json())
          .then(data => {
            console.log('✅ Added to cart:', data);
            
            // Öppna cart notification popup
            const cartNotification = document.querySelector('cart-notification');
            if (cartNotification && typeof cartNotification.open === 'function') {
              cartNotification.open();
            }
          })
          .catch(err => {
            console.error('❌ Cart add failed:', err);
            alert('Kunde inte lägga till i varukorgen. Försök igen.');
          });
          
          return false;
        }

        }
      }
      
      // Log final values (för andra produkter)
      const keyringField = document.getElementById('hidden-keyring-type');
      const designField = document.getElementById('hidden-nobody-design');
      const minteddyDesignField = document.getElementById('hidden-minteddy-design');
      const heartColorField = document.getElementById('hidden-heart-color');
      
      console.log('Final keyring value:', keyringField ? keyringField.value : 'not found');
      console.log('Final Nobody design value:', designField ? designField.value : 'not found');
      console.log('Final MinTeddy design value:', minteddyDesignField ? minteddyDesignField.value : 'not found');
      console.log('Final MinTeddy heart color value:', heartColorField ? heartColorField.value : 'not found');
      
    }, { once: false, capture: true });  // ← Lägg till capture: true



    });
  }
  
  // Start trying to attach form listener
  attachFormSubmitListener();

  // Font mapping for preview (same as global.js)
  const fontMap = {
    'Pacifico': 'Pacifico, cursive',
    'Noto Sans': 'Noto Sans, sans-serif',
    'Audiowide': 'Audiowide, cursive',
    'Limelight': 'Limelight, cursive',
    'Press Start 2P': '"Press Start 2P", cursive',
    'Roboto': 'Roboto, sans-serif',
    'Dancing Script': '"Dancing Script", cursive',
    'Playwrite CU': '"Playwrite CU", cursive',
    'Satisfy': 'Satisfy, cursive',
    'Rochester': 'Rochester, cursive',
    'Great Vibes': '"Great Vibes", cursive',
    'Arizonia': 'Arizonia, cursive',
    'Anton': 'Anton, sans-serif',
    'Bebas_Neue': '"Bebas Neue", sans-serif',
    'Lobster-Regular': 'Lobster, cursive',
    'Playfair_Display': '"Playfair Display", serif',
    'Sacramento': 'Sacramento, cursive'
  };

  function handleBlockifierFontRestriction() {
    
    // Funktion för att hantera font-visning
    function updateFontVisibility() {
      // Hitta valt Typ-värde
      let selectedType = null;
      
      // Kolla radio buttons med name="Typ-1"
      const checkedRadio = document.querySelector('input[name="Typ-1"]:checked');
      if (checkedRadio) {
        selectedType = checkedRadio.value;
      }
      
      console.log('Selected Type:', selectedType);
      
      // Hitta Font-väljaren (fieldset)
      const fontFieldsets = document.querySelectorAll('fieldset.product-form__input');
      let fontFieldset = null;
      
      fontFieldsets.forEach(fieldset => {
        const legend = fieldset.querySelector('legend');
        if (legend && legend.textContent.includes('Font')) {
          fontFieldset = fieldset;
        }
      });
      
      if (!fontFieldset) {
        console.log('Font fieldset not found');
        return;
      }
      
      // Om Blockifiera är valt
      if (selectedType === 'Blockifiera ditt namn') {
        console.log('Blockifiera selected - hiding other fonts');
        
        // Hitta alla font-inputs
        const fontInputs = fontFieldset.querySelectorAll('input[type="radio"]');
        
        fontInputs.forEach(input => {
          const label = document.querySelector(`label[for="${input.id}"]`);
          
          if (input.value === 'Press Start 2P') {
            // Visa och välj Press Start 2P
            if (label) label.style.display = '';
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            // Dölj alla andra fonts
            if (label) label.style.display = 'none';
          }
        });
        
        // Lägg till meddelande
        let blockifierMessage = fontFieldset.querySelector('.blockifier-message');
        if (!blockifierMessage) {
          blockifierMessage = document.createElement('p');
          blockifierMessage.className = 'blockifier-message';
          blockifierMessage.style.cssText = 'font-size: 12px; color: #666; margin-top: 10px;';
          blockifierMessage.textContent = 'Blockifiering använder endast Press Start 2P-fonten';
          fontFieldset.appendChild(blockifierMessage);
        }
      } else {
        console.log('Other type selected - showing all fonts');
        
        // Visa alla fonts igen
        const fontInputs = fontFieldset.querySelectorAll('input[type="radio"]');
        
        fontInputs.forEach(input => {
          const label = document.querySelector(`label[for="${input.id}"]`);
          if (label) label.style.display = '';
        });
        
        // Ta bort meddelande
        const blockifierMessage = fontFieldset.querySelector('.blockifier-message');
        if (blockifierMessage) {
          blockifierMessage.remove();
        }
      }
    }
    
    // Lyssna på ändringar på Typ-inputs
    const typeInputs = document.querySelectorAll('input[name="Typ-1"]');
    typeInputs.forEach(input => {
      input.addEventListener('change', updateFontVisibility);
    });
    
    // Kör vid sidladdning
    setTimeout(updateFontVisibility, 500);
  }
  
  // Kör bara på produktsidor
  if (window.location.pathname.includes('/products/')) {
    handleBlockifierFontRestriction();
  }

  // Force update MinTeddy fields on page load
  // Force update MinTeddy fields on page load
  setTimeout(function() {
    console.log('=== FORCE UPDATE MINTEDDY ON LOAD ===');
    
    // Auto-select first design if none selected
    const firstDesign = document.querySelector('.design-radio[name="minteddy_design_selection"]');
    if (firstDesign && !document.querySelector('.design-radio[name="minteddy_design_selection"]:checked')) {
      firstDesign.checked = true;
      firstDesign.dispatchEvent(new Event('change'));
      console.log('Auto-selected first MinTeddy design');
    }
    
    // Auto-select first bear color if none selected
    const firstBearColor = document.querySelector('input[name="bear_color_selection"]');
    if (firstBearColor && !document.querySelector('input[name="bear_color_selection"]:checked')) {
      firstBearColor.checked = true;
      firstBearColor.dispatchEvent(new Event('change'));
      console.log('Auto-selected first bear color');
    }
    
    // Auto-select first heart color if none selected
    const firstHeartColor = document.querySelector('input[name="heart_color_selection"]');
    if (firstHeartColor && !document.querySelector('input[name="heart_color_selection"]:checked')) {
      firstHeartColor.checked = true;
      firstHeartColor.dispatchEvent(new Event('change'));
      console.log('Auto-selected first heart color');
    }
    
  }, 1000);

}); // End DOMContentLoaded
